// Import dependencies
import React, {Component} from 'react';

// Import css
import './Arrow.css';

// Import images
import arrow from '../../resources/icons/long-arrow.svg'


export default class Arrow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            circleAnim: '',
            arrowAnim: '',
        };
        this.hoverComponent = this.hoverComponent.bind(this);
    }

    // Animates container on hover
    hoverComponent()
    {
        this.state.circleAnim === 'arrow__container-highlight' ?
            this.props.left ?
                this.setState({
                    circleAnim: 'arrow__container-tint',
                    arrowAnim: 'arrow__arrow-dehover-left'
                })
                :
                this.setState({
                    circleAnim: 'arrow__container-tint',
                    arrowAnim: 'arrow__arrow-dehover-right'
                })
            :
            this.props.left ?
                this.setState({
                    circleAnim: 'arrow__container-highlight',
                    arrowAnim: 'arrow__arrow-hover-left'
                })
                :
                this.setState({
                    circleAnim: 'arrow__container-highlight',
                    arrowAnim: 'arrow__arrow-hover-right'
                })
    }

    render() {
        return (
            <div
                className={'arrow__container ' + this.state.circleAnim}
                onMouseEnter={this.hoverComponent}
                onMouseLeave={this.hoverComponent}
            >
                <div className={this.props.left ? 'arrow__two-arrow-container '+this.state.arrowAnim : 'arrow__two-arrow-container-right '+this.state.arrowAnim}>
                    <div className='arrow__container-inner'>
                        <img
                            src={arrow}
                            className='arrow__icon'
                            alt='carousel-arrow'
                            style={ this.props.left ? { transform: 'rotate(180deg)' } : null }
                        />
                    </div>
                    <div className='arrow__container-inner'>
                        <img
                            src={arrow}
                            className='arrow__icon'
                            alt='carousel-arrow'
                            style={ this.props.left ? { transform: 'rotate(180deg)' } : null }
                        />
                    </div>
                </div>
            </div>
        );
    }
}
